import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from "@angular/core";
import { finalize } from "rxjs/operators";
import { GroupAttrService } from "../../../models/group-attr.service";
import { ProjectAttrService } from "../../../models/project-attr.service";
import { StdAttrsService } from "../../../std-attrs/std-attrs.service";

@Component({
  selector: "ab-attr-preview",
  templateUrl: "./attr-preview.component.html",
})
export class AttrPreviewComponent implements OnInit, OnChanges {
  @Input() public project: any;
  @Input() public group: any;
  @Output() public created = new EventEmitter();

  public selectedAttr: any;
  public loading: boolean;
  public attr: any;
  public attrNoticeCount: number;
  public creating: boolean;
  public availableAttrs: any;
  public allAttrs: any;
  public projectAttrsLeft: number;
  public groupAttrsLeft: number;

  private MAX_ATTRS = 3;

  constructor(
    private groupAttrService: GroupAttrService,
    private projectAttrService: ProjectAttrService,
    private stdAttrsService: StdAttrsService,
  ) {}

  public trackByIndex(index: number, _item: any) {
    return index;
  }

  public previewAttr(noticeId?: string) {
    const params: any = {
      projectId: this.group.projectId,
      groupId: this.group.id,
      attribute: this.selectedAttr,
    };
    if (noticeId) {
      params.noticeId = noticeId;
    }

    this.loading = true;
    return this.groupAttrService
      .preview(params)
      .pipe(
        finalize(() => {
          this.loading = false;
        }),
      )
      .subscribe((data: any) => {
        if (noticeId) {
          for (const newAttr of data.attributes) {
            this.mergeAttr(newAttr);
          }
          this.attr.lastNoticeId = data.lastNoticeId;
        } else {
          this.attr = data;
        }

        this.attrNoticeCount = 0;
        for (const attr of this.attr.attributes) {
          this.attrNoticeCount += attr.noticeCount;
        }
      });
  }

  public createProjectAttr() {
    const params = {
      projectId: this.group.projectId,
      attribute: this.selectedAttr,
    };

    this.creating = true;
    return this.projectAttrService
      .create(params)
      .pipe(
        finalize(() => {
          this.creating = false;
        }),
      )
      .subscribe((_data: any) => {
        this.created.emit({ attrKey: this.selectedAttr, projectAttr: true });
        this.attr.created = true;
      });
  }

  public createGroupAttr() {
    const params = {
      projectId: this.group.projectId,
      groupId: this.group.id,
      attribute: this.selectedAttr,
    };

    this.creating = true;
    return this.groupAttrService
      .create(params)
      .pipe(
        finalize(() => {
          this.creating = false;
        }),
      )
      .subscribe((_data: any) => {
        this.created.emit({ attrKey: this.selectedAttr });
        return (this.attr.created = true);
      });
  }

  public ngOnInit() {
    const params = {
      projectId: this.group.projectId,
      groupId: this.group.id,
    };
    this.groupAttrService.names(params).subscribe((data: any) => {
      this.allAttrs = data.attributes;
      this.setAvailableAttrs(this.allAttrs);
    });
  }

  public ngOnChanges() {
    if (this.allAttrs) {
      this.setAvailableAttrs(this.allAttrs);
    }
  }

  private mergeAttr(newAttr: any) {
    for (const attr of this.attr.attributes) {
      if (attr.value !== newAttr.value) {
        continue;
      }

      attr.noticeCount += newAttr.noticeCount;
      if (newAttr.firstSeenAt < attr.firstSeenAt) {
        attr.firstSeenAt = newAttr.firstSeenAt;
      }
      if (newAttr.lastSeenAt > attr.lastSeenAt) {
        attr.lastSeenAt = newAttr.lastSeenAt;
      }
      return;
    }

    return this.attr.attributes.push(newAttr);
  }

  private setAvailableAttrs(attrs: any) {
    this.projectAttrsLeft = this.MAX_ATTRS - this.project.attributes.length;
    this.groupAttrsLeft = this.MAX_ATTRS - this.group.attributes.length;

    this.availableAttrs = attrs.filter((attr: any) => {
      // Don't offer attributes that are already aggregated.
      if (this.project.attributes.indexOf(attr) !== -1) {
        return false;
      }
      if (this.group.attributes.indexOf(attr) !== -1) {
        return false;
      }

      // Don't offer attributes which are given as standard aggregations.
      for (const stdAttr of this.stdAttrsService.getAttrs()) {
        if (stdAttr.key === attr) {
          return false;
        }
      }

      return true;
    });
  }
}
